import { CENTRO_GALLERY } from "../lib/site";

export default function Centro() {
  return (
    <section
      id="centro"
      data-testid="centro-section"
      translate="no"
      lang="it"
      className="notranslate relative py-24 sm:py-32 bg-[var(--ee-cream)]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="ee-eyebrow">I nostri spazi</div>
          <h2
            data-testid="centro-title"
            className="font-serif-display mt-4 text-[34px] sm:text-[46px] lg:text-[54px] leading-[1.08] tracking-[-0.01em] text-[var(--ee-ink)]"
          >
            Un ambiente pensato
            <em className="italic text-[var(--ee-rose-strong)]"> per te</em>.
          </h2>
          <p className="mt-5 text-[15px] sm:text-[16px] leading-[1.7] text-[var(--ee-ink-soft)]">
            Spazi curati, attrezzature professionali, un'atmosfera accogliente
            per ogni trattamento.
          </p>
        </div>

        {/* Gallery: desktop 3 colonne side-by-side, mobile scroll orizzontale swipeable */}
        <div
          data-testid="centro-gallery"
          className="mt-12 flex sm:grid sm:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none -mx-5 sm:mx-0 px-5 sm:px-0 pb-2 sm:pb-0"
          style={{ scrollbarWidth: "none" }}
        >
          {CENTRO_GALLERY.map((p, i) => (
            <div
              key={p.src}
              data-testid={`centro-photo-${i}`}
              className="flex-shrink-0 w-[78%] sm:w-auto snap-center ee-img-frame aspect-[4/5] transition-transform duration-300 hover:scale-[1.02]"
              style={{ animation: `ee-fade-up 0.7s ease-out ${i * 0.08}s both` }}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
